/**
 * Controller para a diretiva de paginação de itens. 
 */

angular.module("avlib").controller("paginatorController", 
		["$scope", function PaginatorController($scope) {
			
	/**
	 * Número máximo de slots disponível para apresentação das páginas. 
	 */
	var MAX_VISIBLE_PAGES = 7;
	
	/**
	 * Número mínimo de páginas que deve ser apresentado no bloco inicial de páginas. 
	 */
	var MINIMUM_VISIBLE_FIRST_PAGES = 2;
	
	/**
	 * Número mínimo de páginas que deve ser apresentado no bloco final de páginas. 
	 */
	var MINIMUM_VISIBLE_LAST_PAGES = 2;
	
	/**
	 * Calcula quantidade de páginas necessárias para apresentar todos os itens da sequência
	 * e define a forma de apresentação das páginas no navegador.
	 */
	var refreshPagination = function(){
		$scope.ngModel.pageCount = Math.ceil($scope.ngModel.itemCount / $scope.ngModel.pageSize);
		/*
		 * Caso a quantidade de itens tenha sido alterada, por um mecanismo de filtragem, por exemplo,
		 * o índice da página corrente pode ter ficado fora da faixa de páginas válidas. Vamos corrigir
		 * eventual inconsistência agora:  
		 */
		if ($scope.ngModel.pageCount > 0 && $scope.ngModel.currentPage >= $scope.ngModel.pageCount){
			$scope.ngModel.currentPage = $scope.ngModel.pageCount-1;
		}
		/*
		 * Dependendo da quantidade de páginas, iremos apresentá-las na interface ou na sua totalidade,
		 * ou resumidas em até três blocos de páginas. O bloco inicial, bloco intermediário e bloco
		 * final. Os índices abaixo será utilizados para controlar qual a primeira e última página
		 * de cada um destes blocos. A configuração inicial, prevê a apresentação da totalidade das
		 * páginas. Então apenas o primeiro bloco será usado. Por isso, foi configurado com o número
		 * total de páginas. Os outros dois blocos foram configurados com valores que os tornam
		 * inoperantes.  
		 */
		var firstPageCount = $scope.ngModel.pageCount;
		var middlePagesBegin = 1;
		var middlePagesEnd = 0;
		var lastPagesBegin = $scope.ngModel.pageCount+1;
		/*
		 * Se a quantidade de páginas é superior ao máximo de páginas admitidas, então precisaremos
		 * utilizar alguma estratégia de supressão de algumas páginas. A estratégia utilizada
		 * será determinada em função da página selecionada no momento.
		 */
		if ($scope.ngModel.pageCount > MAX_VISIBLE_PAGES){
			/*
			 * Se a página corrente está localizada no início da sequência de páginas, vamos apresentar
			 * na interface o maior número possível de páginas iniciais (bloco inicial), seguidas de
			 * reticências e um mínimo de páginas do final da sequência (bloco final).
			 */
			if ($scope.ngModel.currentPage+2+MINIMUM_VISIBLE_LAST_PAGES <= MAX_VISIBLE_PAGES){
				firstPageCount = MAX_VISIBLE_PAGES-MINIMUM_VISIBLE_LAST_PAGES-1;
				lastPagesBegin = $scope.ngModel.pageCount - MINIMUM_VISIBLE_LAST_PAGES+1;
				/*
				 * De forma similar, se a página corrente está localizado no final da sequência de páginas,
				 * vamos apresentar o maior número de páginas finais possível, precedido de reticências
				 * e um mínimo de páginas do início da sequência.
				 */
			}else if (($scope.ngModel.pageCount - $scope.ngModel.currentPage)+MINIMUM_VISIBLE_FIRST_PAGES+1 <= MAX_VISIBLE_PAGES){
				firstPageCount = MINIMUM_VISIBLE_FIRST_PAGES;
				lastPagesBegin = $scope.ngModel.pageCount - (MAX_VISIBLE_PAGES-MINIMUM_VISIBLE_FIRST_PAGES-2);
			}else{
				/*
				 * Por fim, se a página corrente está localizada na parte central da sequência, apresentaremos
				 * um mínimo de páginas inicias, um mínimo de páginas finais e entre elas, algumas páginas
				 * intermediárias, dentre elas, a página selecionada.
				 */
				firstPageCount = MINIMUM_VISIBLE_FIRST_PAGES;
				lastPagesBegin = $scope.ngModel.pageCount - MINIMUM_VISIBLE_LAST_PAGES +1;
				/*
				 * Vamos tentar posicionar a página corrente bem no meio do bloco de páginas intermediárias.
				 * Para isso, calcularemos a quantidade de páginas disponíveis no bloco intermediário.
				 */
				var remainingPages = MAX_VISIBLE_PAGES-MINIMUM_VISIBLE_FIRST_PAGES-MINIMUM_VISIBLE_LAST_PAGES-2;
				var beforeCurrentPages = Math.floor(remainingPages / 2);
				var afterCurrentPages = remainingPages-1-beforeCurrentPages;
				middlePagesBegin = $scope.ngModel.currentPage+1 - beforeCurrentPages;
				middlePagesEnd = $scope.ngModel.currentPage+1 + afterCurrentPages;
			}
		}
		/*
		 * Através do algoritmo acima, analisamos o posicionamento da página selecionada e determinamos
		 * como será apresentado na interface um subconjunto das páginas totais. Este subconjunto pode
		 * ser dividido Como resultado deste
		 * algoritmo calculamos os índices que indicam em que página começa e termina    
		 */
		$scope.firstPages = [];
		for (var i=1; i<=firstPageCount; i++)
			$scope.firstPages.push(i);
		
		$scope.middlePages = [];
		for (var i=middlePagesBegin; i<=middlePagesEnd; i++)
			$scope.middlePages.push(i);
		
		$scope.lastPages = [];
		for (var i=lastPagesBegin; i<=$scope.ngModel.pageCount; i++)
			$scope.lastPages.push(i);
	};

	/**
	 * Listener para os botões de seleção de uma página específica.
	 */
	$scope.pageClicked = function(page){
		$scope.ngModel.currentPage = page-1;
		refreshPagination();
	};
	
	/**
	 * Listener para o botão de avançar na sequência de páginas.
	 */
	$scope.nextPageButtonClicked = function(){
		$scope.ngModel.currentPage++;
		refreshPagination();
	};
	
	/**
	 * Listener para o botão de retroceder na sequência de páginas.
	 */
	$scope.previousPageButtonClicked = function(){
		$scope.ngModel.currentPage--;
		refreshPagination();
	};
	
	/**
	 * Indica quando o botão de retroceder na sequência de páginas deve estar habilitado na interface.
	 */
	$scope.isPreviousPageButtonEnabled = function(){
		return $scope.ngModel.currentPage > 0;
	};
	
	/**
	 * Indica quando o botão de avançar na sequência de páginas deve estar habilitado na interface.
	 */
	$scope.isNextPageButtonEnabled = function(){
		return $scope.ngModel.currentPage+1 < $scope.ngModel.pageCount;
	};
	
	/**
	 * Indica quando os botões de avançar e retroceder na sequência de páginas devem estar visíveis na interface.
	 */
	$scope.showNavigationButtons = function(){
		return $scope.ngModel.pageCount > MAX_VISIBLE_PAGES;
	};
	
	/*
	 * Precisamos receber eventos de alteração na quantidade total de itens a ser exibidos e
	 * na quantidade de itens comportados por página para podermos atualizar o navegador
	 * de páginas de acordo. 
	 */
	$scope.$watch('ngModel.itemCount', refreshPagination);
	$scope.$watch('ngModel.pageSize', refreshPagination);
}]);
